import { useMixpanelTrackers } from "@jidlomat/terminal-core/hooks/useMixpanelTrackers";
import { useAppSelector } from "@jidlomat/terminal-core/hooks/utilsHooks/storeHooks";
import { selectShortFridgeId } from "@jidlomat/terminal-core/slices/fridgeInfoSlice";
import { logToSentry } from "@jidlomat/terminal-core/utils/logger";
import { BasicModal } from "@jidlomat/terminal-ui/components/global/modals/BasicModal";
import { ErrorBox } from "@jidlomat/terminal-ui/components/primitives/ErrorBox";
import { ModalContentWrapper } from "@jidlomat/terminal-ui/components/primitives/ModalContentWrapper";
import { ModalTitle } from "@jidlomat/terminal-ui/components/primitives/ModalTitle";
import { Typography } from "@mui/material";
import parse from "html-react-parser";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import EmptyFridgeIllustration from "../../../assets/illustrations/emptyFridgeImage.svg";

const EmptyFridgeModalContent = () => {
	const fridgeId = useAppSelector(selectShortFridgeId);
	const { t } = useTranslation();
	const { trackTabletEmptyFridgeModal } = useMixpanelTrackers();

	// biome-ignore lint/correctness/useExhaustiveDependencies: intentionally mount/unmount-only for tracking
	useEffect(() => {
		trackTabletEmptyFridgeModal("open");
		logToSentry(`Empty fridge modal displayed on fridge: ${fridgeId}`, "info");
		return () => {
			trackTabletEmptyFridgeModal("close");
		};
	}, []);

	return (
		<ModalContentWrapper>
			<ModalTitle variant="promoHeader">{t("modals.emptyFridgeModal.title")}</ModalTitle>
			<Typography variant="promoText">{t("modals.emptyFridgeModal.description")}</Typography>
			<EmptyFridgeIllustration />
			<ErrorBox mt="auto">
				<Typography display="flex" variant="ctaSubtextBold" color="white" textAlign="center">
					{parse(t("modals.emptyFridgeModal.banner"))}
				</Typography>
			</ErrorBox>
			<Typography variant="filter">
				{t("modals.emptyFridgeModal.fridgeId")}: {fridgeId}
			</Typography>
		</ModalContentWrapper>
	);
};

export const EmptyFridgeModal = () => (
	<BasicModal modalContent={<EmptyFridgeModalContent />} open={true} closable={false} fullHeight={true} />
);
